import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import VueGtag from 'vue-gtag';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import { i18n } from './plugins/i18n';
import './plugins/vee-validate';

Vue.use(
	VueGtag,
	{
		config: { id: process.env.VUE_APP_G_TAG },
		pageTrackerTemplate(to) {
			return {
				page_title: to.path,
				page_path: to.path,
			};
		},
	},
	router,
);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.config.productionTip = false;

const firebaseConfig = {
	apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
	authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
	databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
	projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.VUE_APP_FIREBASE_APP_ID,
	scopes: ['email', 'profile'],
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);

if (process.env.NODE_ENV === 'production') {
	// Sentry initialization removed
}

new Vue({
	vuetify,
	i18n,
	render: h => h(App),
	router,
	store,
}).$mount('#app');

export { firebaseApp, db, auth };
